// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"bb1932e7","856":"92de2202"}[chunkId] + ".chunk.css";
};